import { useQuery } from 'react-query';
import { TeleprompterParams } from './types';
import { teleprompterKeys } from './queryKeys';
import { EXPRESS_API } from 'configs/api/expressApi';

export interface TeleprompterUser {
  firstName: string;
  lastName: string;
}

export interface TeleprompterScript {
  scriptId: number;
  title: string;
  content: string;
  createdAt: string;
  customerId: number;
  sharedWithAll: boolean;
  sharedWithCompany: boolean;
  user: TeleprompterUser;
  userId: number;
}

export interface TeleprompterScriptsResponse {
  count: number;
  scripts: TeleprompterScript[];
}

const getTeleprompterScripts = async (
  params?: TeleprompterParams
): Promise<TeleprompterScriptsResponse> => {
  const response = await EXPRESS_API.get(`/teleprompter`, {
    params: { ...params, field: 'createdAt', order: 'desc' },
  });
  return response.data;
};

export const useGetTeleprompterScripts = (params?: TeleprompterParams) => {
  return useQuery(teleprompterKeys.list(params?.scope || ''), () =>
    getTeleprompterScripts(params)
  );
};
